import OurServiceSection from '../../Components/OurServiceSection'
import UnbeatableSection from '../../Components/UnbeatableSection'
import './styles.scss'

import titleIcon1 from '../../Assets/Images/title-icon-1.png'
import about1 from '../../Assets/Images/about-1.jpg'
import AnimateOnScroll from '../../Components/AnimateOnScroll'

const AboutUs = () => {
  return (
    <div className="about-us">
      <div className="about-us__top">
        <h1>About Us</h1>
      </div>

      <div className="about-us__content">
        <section>
          <AnimateOnScroll animation="fade-right" className="section1-col">
            <span className="title-text">
              <img src={titleIcon1} alt="" />
              Who We Are?
            </span>

            <h4>Over 30 years of experience in Logistics services</h4>

            <p>
              We’re one of the leading independent shipping and logistics
              providers. Trusted since 1993 by some of the world’s leading
              companies, we provide liner
              <br /> and port agency services, freight forwarding by sea, air
              and road, warehousing & distribution services and end-to-end
              supply chain management.
            </p>
          </AnimateOnScroll>

          <AnimateOnScroll animation="fade-left" delay={200} className="section1-col">
            <img src={about1} alt="" />
          </AnimateOnScroll>
        </section>

        <section>
          <AnimateOnScroll animation="fade-up" className="testimonial">
            <h4>Mission</h4>

            <p>
              As a client-centred Logistics Company, our mission is to offer
              high-performance solutions that exceed customer expectations
              through high quality service, cost control, continuous upgrading
              of technology and development of our human capital.
            </p>
          </AnimateOnScroll>

          <AnimateOnScroll animation="fade-up" delay={150} className="testimonial">
            <h4>Vision</h4>

            <p>
              It shall be the endeavor of Farze Global Logistics to
              surpass customer expectations through Innovation, Creativity and
              an uncompromising commitment to Quality, Transparency and
              Integrity in offering total logistic solutions.
            </p>
          </AnimateOnScroll>
        </section>

        <UnbeatableSection />

        <OurServiceSection />
      </div>
    </div>
  )
}

export default AboutUs
